import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { green } from '@material-ui/core/colors';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles({
    card: {
        minWidth: 275,
    },
    avatar: {
        backgroundColor: green[500],
    },
    billText: {
        margin: 5,
    },
    totalPrice: {
        marginLeft: 5,
        marginTop: 15,
    },
});

export default function Bill(props) {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardContent>
                <Typography variant="body1" className={classes.billText}>
                    이용요금 : {props.originalPrice} 원
                </Typography>
                <Typography variant="body1" className={classes.billText}>
                    연회원 할인 : -{props.memberDiscount} 원
                </Typography>

                {props.doubleDiscount > 0 ? (
                    <Typography variant="body1" className={classes.billText}>
                        추가 할인 : -{props.doubleDiscount} 원
                    </Typography>
                ) : (<div></div>)}

                <Typography variant="body1" className={classes.billText}>
                    잔액 사용 : -{props.usePoint} 원 (내 잔액 : {props.myPoint} 원)
                </Typography>
                <Divider />
                <Typography variant="h6" className={classes.totalPrice}>
                    총 결제 금액 : {props.totalPrice} 원
                </Typography>
            </CardContent>
        </Card>
    );
}


// WEBPACK FOOTER //
// ./src/components/seat/Bill.js